import styled from 'styled-components';

export const StyledTimeTableContainer = styled.div`
  margin-top: 40px;
`;

export const StyledColorContainer = styled.div`
  display: grid;
  justify-content: center;
  gap: 30px;
  margin-left: 40px;
`;

export const StyledTimeTable = styled.div`
  @media (max-width: 1224px) {
    margin-left: -15px;
    margin-right: -15px;
  }
`;
